import { render, staticRenderFns } from "./FinanceSalarySliceTableItem.vue?vue&type=template&id=a513f4ca&scoped=true&"
import script from "./FinanceSalarySliceTableItem.vue?vue&type=script&lang=js&"
export * from "./FinanceSalarySliceTableItem.vue?vue&type=script&lang=js&"
import style0 from "./FinanceSalarySliceTableItem.vue?vue&type=style&index=0&id=a513f4ca&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a513f4ca",
  null
  
)

export default component.exports